import { debounce } from '@/common/utils/debounce';
import React, { useCallback, useRef } from 'react';
import { View, Text, TouchableOpacity, ViewStyle, TextStyle, ImageStyle } from 'react-native';
import { Styles } from './ButtonStyle';
import { useDebounceFn } from 'ahooks';

export default function Button(props: {
    children?: any;
    onPress?: any;
    style?: ViewStyle | TextStyle | ImageStyle | ViewStyle[];
    textStyle?: TextStyle;
    type?: 'default' | 'primary' | 'text' | 'white';
    size?: 'mini' | 'small' | 'middle' | 'large' | 'huge';
    shape?: 'rect' | 'round';
    disabled?: boolean;
    allowPress?: boolean; // 禁用状态下也能执行点击事件
    wrapperStyle?: ViewStyle;
    wait?: number;
}) {
    const {
        children,
        onPress = console.log,
        style = {},
        wrapperStyle = {},
        textStyle,
        type = 'default',
        size = 'middle',
        shape = 'rect',
        disabled = false,
        wait = 300,
    } = props;
    const preClickTime = useRef(0);

    // 节流300毫秒
    const { run: onThrottledPress } = useDebounceFn(
        () => {
            onPress();
        },
        {
            leading: true,
            trailing: false,
            wait: wait ?? 300,
        },
    );
    return (
        <TouchableOpacity
            activeOpacity={0.6}
            style={wrapperStyle}
            onPress={(event) => {
                if (!disabled) {
                    onThrottledPress();
                } else if (props?.allowPress) {
                    onThrottledPress();
                }
            }}
        >
            <View
                style={[
                    Styles.box.default,
                    Styles.box.type[type],
                    Styles.box.size[size],
                    Styles.box.shape[shape],
                    Styles.box.disabled[disabled.toString()],
                    style,
                ]}
            >
                <Text style={[Styles.text.type[type], Styles.text.size[size], textStyle]}>{children}</Text>
            </View>
        </TouchableOpacity>
    );
}

export function ButtonWrapper(props: {
    children: any;
    onPress?: any;
    style?: ViewStyle | ViewStyle[];
    className?: string | string[];
    disabled?: boolean;
    throttledNum?: number;
}) {
    // 节流300毫秒
    const onThrottledPress = useCallback(
        debounce(() => {
            props.onPress?.();
        }, props?.throttledNum || 200),
        [props.onPress],
    );

    return (
        <TouchableOpacity
            className={props.className}
            style={props.style}
            activeOpacity={props.disabled ? 1 : 0.6}
            onPress={() => {
                if (!props.disabled) {
                    onThrottledPress();
                }
            }}
            disabled={props.disabled}
        >
            {typeof props.children === 'string' ? <Text style={props.style}>{props.children}</Text> : props.children}
        </TouchableOpacity>
    );
}
